import styled from 'styled-components'

import {
    RecommendationsHead,
    RecommendationsBody,
    Empty,
    NothingFound,
} from './tableComponents'
import Table, {TableFilter} from '../../../myTable/MyTable'
import {useAppSelector} from '../../../../hooks/redux'
import {useState} from 'react'
import {MAX_PER_PAGE} from '../../../../constants/other'
import {getSubjectId} from "../../../../pages/biomarkers/[id]/IndicatorsAndSignals";
import {TableStyle} from "../interpretation/InterpretationTable";
import { getLocalizedText } from '../../../../utils/localize'



const RecommendationsTable = (props:any) => {
    const {recommendations} = useAppSelector((state) => state.data)
    const { language = 'en' } = props
    let [filter, setFilter] = useState({
        sort: 'name',
        perPage: MAX_PER_PAGE,
        search: '',
        direction: 'asc',
        // filter: {_id: 1}
    })

    const hasdata = Object.values(recommendations).length > 0 ? 'true' : 'false'

    return (
        <>
            <TableFilter filter={filter} setFilter={setFilter}
                         name={'Create New Recommendation'}
                         url={'/' + getSubjectId() + '/recommendations/create-recommendation'}
            ></TableFilter>
            <TableStyle hasdata={hasdata}>
                <Table
                    Head={RecommendationsHead}
                    Body={(props: any) => <RecommendationsBody {...props} language={language} />}
                    EmptyItems={Empty}
                    NothingFound={NothingFound}
                    apiSearchFileds={['name']}
                    onConnect={props.onConnect}
                    connectIds={props.connectIds}
                    onFilter={(it: any, filter: any) => {
                        if (filter._id) {
                            return it._id == filter._id
                        }
                        return true
                    }}
                    onSearch={(it: any, reg: any) => {
                        return reg.test(getLocalizedText(it.name, language))
                    }}
                    onChangeFilter={(v: any) => {
                        setFilter(v)
                    }}
                    filter={filter}
                    items={Object.values(recommendations)}
                />
            </TableStyle>
        </>
    )
}

export default RecommendationsTable
